import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useSearchParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { AppShell } from "../components/layout/AppShell";
import { NeuButton } from "../components/neu/Neu";
import { useDirtyNavigate } from "../context/DirtyGuard";
import { listBranches } from "../api/directory";
import { BranchForm } from "../features/admin/BranchForm";
import { BranchDangerZone } from "../features/admin/BranchDangerZone";
import { BranchHistory } from "../features/admin/BranchHistory";
import { EffectivePolicyCard } from "../features/admin/EffectivePolicyCard";
import { localName } from "../lib/localName";

// Branch card page: editing and deleting happen here, never from the list.
export default function BranchDetailPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [params] = useSearchParams();
  const guardNavigate = useDirtyNavigate();
  const [branch, setBranch] = useState(null);
  const [loading, setLoading] = useState(true);
  const [version, setVersion] = useState(0);
  const [activeTab, setActiveTab] = useState(params.get("tab") || "basics");

  const load = async () => {
    const all = await listBranches();
    setBranch(all.find((b) => b.id === id) || null);
    setVersion((v) => v + 1);
    setLoading(false);
  };
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <AppShell
      title={branch?.name || t("org.title")}
      subtitle={localName(branch) || branch?.address}
      actions={
        <NeuButton
          data-testid="branch-back"
          className="flex items-center gap-2"
          onClick={() => guardNavigate("/branches")}
        >
          <ArrowRight className="h-4 w-4" /> {t("branches.back")}
        </NeuButton>
      }
    >
      {loading ? (
        <p className="text-sm text-muted-foreground">{t("app.loading")}</p>
      ) : !branch ? (
        <p className="text-sm text-muted-foreground" data-testid="branch-missing">
          {t("app.none")}
        </p>
      ) : (
        <div className="detail-zoom grid gap-6" data-testid="branch-detail">
          <BranchForm
            initial={branch}
            initialTab={params.get("tab") || "basics"}
            onTabChange={setActiveTab}
            onSaved={load}
            onCancel={() => guardNavigate("/branches")}
          />
          <BranchHistory key={version} branchId={branch.id} />
          {activeTab === "basics" ? (
            <>
              <EffectivePolicyCard key={`policy-${version}`} branchId={branch.id} />
              <BranchDangerZone branch={branch} />
            </>
          ) : null}
        </div>
      )}
    </AppShell>
  );
}
